import React from 'react'
import { UnderwritingOffer } from '_gql'

import { useCanary } from '@bill/canary.react'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import Spinner from '@divvy-web/skylab.spinner'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'
import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import useDivvyUUID from '@sputnik/hooks/useDivvyUUID'
import CreditLineOffersPage from '@sputnik/pages/PostApplicationPages/CreditLineOffersPage'

import { useGetEligibleOffers } from './GetEligibleOffers.gql'
import styles from './styles.module.scss'

const EligibleOffersPage = () => {
  const [getClassName] = useNameFormatter('EligibleOffersPage')
  const isUWPageRedesign = useCanary('rollout-uw-page-redesign')

  const [companyDivvyUuid] = useDivvyUUID()

  const { data: decisionsData, loading: isLoadingDecisionData } = useGetEligibleOffers({
    skip: !companyDivvyUuid || !isUWPageRedesign,
    variables: { companyId: companyDivvyUuid },
  })

  if (!isUWPageRedesign) {
    return <CreditLineOffersPage />
  }

  const decisions = decisionsData?.decisions || []

  const standardLineOffer = decisions?.find((decision) => decision?.offerType === UnderwritingOffer.FIXED_LINE)
  const variableLineOffer = decisions?.find((decision) => decision?.offerType === UnderwritingOffer.VARIABLE_LINE)
  const securedLineOffer = decisions?.find((decision) => decision?.offerType === UnderwritingOffer.SECURED_LINE)

  const { hasStandardOffer, hasVariableOffer, hasSecuredOffer } = {
    hasStandardOffer: standardLineOffer !== undefined,
    hasVariableOffer: variableLineOffer !== undefined,
    hasSecuredOffer: securedLineOffer !== undefined,
  }

  const offerCount = [hasStandardOffer, hasVariableOffer, hasSecuredOffer].filter(Boolean).length

  if (!decisionsData || isLoadingDecisionData) {
    return (
      <div>
        <Spinner centered />
      </div>
    )
  }

  return (
    <div className={styles[getClassName('')]}>
      <BillBrandLogo />
      <div className={styles[getClassName('content')]}>
        <div className={styles[getClassName('title')]}>
          <FormattedMessage
            defaultMessage='Congrats, you are eligible for {numOffers, plural, one {# offer} other {# offers}}.'
            id='sputnik.EligibleOffersPage__98x1jF'
            values={{ numOffers: offerCount }}
          />
        </div>
        <div className={styles[getClassName('subtitle')]}>
          <FormattedMessage
            defaultMessage='Based on the information provided from you application.'
            id='sputnik.EligibleOffersPage__et15an'
          />
        </div>
        {/* COM-10316: insert new tiles here */}
        {/* COM-10316: insert "included with all offers" info block here */}
        {/* COM-10324: insert application agreement block logic here */}
        <div className={styles[getClassName('footer')]}>
          <GoToDashboardButton
            buttonType={BASIC_BUTTON_TYPE_OUTLINED}
            componentName={getClassName('')}
          />
          {/* COM-10324: add logic to hide this button until they have selected an offer and if !isLoggedInUserAuthorizedSigner */}
          <div>
            <BasicButton
              disabled={false}
              showSpinner={false}
              onClick={() => {}}
            >
              <FormattedMessage
                defaultMessage='Accept offer'
                id='sputnik.EligibleOffersPage__/xro5W'
              />
            </BasicButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EligibleOffersPage
